<style lang="less" scoped>
/* 顶栏 64px + Layout.page-container 上下各 20px + 底部留白 24px（与设计图灰底间隔一致） */
@gaokao-vpad-top: 20px;
@gaokao-vpad-bottom: 20px;
@gaokao-bottom-gap: 24px;

.gaokao-page {
  box-sizing: border-box;
  height: calc(
    100vh - 64px - @gaokao-vpad-top - @gaokao-vpad-bottom - @gaokao-bottom-gap
  );
  max-height: calc(
    100vh - 64px - @gaokao-vpad-top - @gaokao-vpad-bottom - @gaokao-bottom-gap
  );
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* a-spin 撑满高度，避免内部 flex 失效 */
.gaokao-page ::v-deep .ant-spin-nested-loading {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.gaokao-page ::v-deep .ant-spin-container {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.gaokao-layout {
  flex: 1;
  min-height: 0;
  display: flex;
  gap: 16px;
  align-items: stretch;
}

.side-panel {
  flex: 0 0 200px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: 100%;
  background: #fff;
  border-radius: @border-radius-base;
  padding: 12px 0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.side-panel-inner {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.side-item {
  padding: 10px 16px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  text-align: center;

  &:hover {
    color: @primary-color;
  }

  &.active {
    background: @primary-color;
    color: #fff;
  }
}

.main-panel {
  flex: 1;
  min-width: 0;
  min-height: 0;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  border-radius: @border-radius-base;
  padding: 24px 32px;
  box-sizing: border-box;
}

.main-panel ::v-deep .ant-spin-nested-loading {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.main-panel ::v-deep .ant-spin-container {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.main-panel-inner {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 仅列表区域滚动，年份固定在上、分页固定在白框底部 */
.main-panel-list-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.year-row {
  flex-shrink: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  margin-bottom: 16px;
  font-size: 14px;
}

.year-label {
  color: rgba(0, 0, 0, 0.65);
  margin-right: 4px;
}

.year-pill {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 16px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.85);
  transition: all 0.2s;
  border-radius: 99px;
  background: var(--Grey-10, #F6F7F9);

  &:hover {
    color: @primary-color;
  }

  &.active {
    background: @primary-color;
    color: #fff;
  }
}

.toggle-years {
  color: @primary-color;
  cursor: pointer;
  user-select: none;
  border-radius: 99px;
  border: 1px solid @primary-color;
  padding: 2px 16px;

  .anticon {
    margin-left: 4px;
    font-size: 12px;
  }
}

.list-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0;
  border-bottom: 1px solid #f0f0f0;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.85);

  &:last-child {
    border-bottom: none;
  }
}

.list-title {
  flex: 1;
  min-width: 0;
  padding-right: 16px;
  word-break: break-word;
}

.download-link {
  flex-shrink: 0;
  color: @primary-color;
  font-size: 14px;
font-style: normal;
  cursor: pointer;
  border-radius: 6px;
background: #FDEDEE;
padding: 4px 12px;

  &:hover {
    opacity: 0.85;
  }
}

.pagination-wrap {
  flex-shrink: 0;
  margin-top: 12px;
  padding-top: 8px;
  text-align: right;
  border-top: 1px solid #f5f5f5;
}

.empty-tip {
  flex-shrink: 0;
  padding: 40px 0;
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
}
</style>

<template>
  <div class="gaokao-page">
    <a-spin :spinning="classifyLoading">
      <div class="gaokao-layout">
        <aside class="side-panel">
          <div class="side-panel-inner">
            <div
              v-for="c in classifyList"
              :key="c.id"
              :class="['side-item', { active: selectedClassifyId === c.id }]"
              @click="onSelectClassify(c)"
            >
              {{ c.title }}
            </div>
          </div>
        </aside>

        <section class="main-panel">
          <a-spin :spinning="pageLoading">
            <div class="main-panel-inner">
              <div class="year-row">
                <span class="year-label">年份</span>
                <span
                  v-for="y in displayedYears"
                  :key="y.value === '' ? 'all' : y.value"
                  :class="['year-pill', { active: selectedYear === y.value }]"
                  @click="onSelectYear(y.value)"
                >
                  {{ y.label }}
                </span>
                <span
                  v-if="canToggleYears"
                  class="toggle-years"
                  @click="yearExpanded = !yearExpanded"
                >
                  {{ yearExpanded ? '收起' : '展开' }}
                  <a-icon :type="yearExpanded ? 'up' : 'down'" />
                </span>
              </div>

              <div class="main-panel-list-scroll">
                <div v-if="!list.length && !pageLoading" class="empty-tip">
                  暂无真题数据
                </div>

                <div v-for="item in list" :key="item.id" class="list-row">
                  <div class="list-title">{{ item.title }}</div>
                  <span class="download-link" @click="onDownload(item)">下载</span>
                </div>
              </div>

              <div v-if="total > pageSize" class="pagination-wrap">
                <a-pagination
                  :current="pageNum"
                  :page-size="pageSize"
                  :total="total"
                  size="small"
                  @change="onPageChange"
                />
              </div>
            </div>
          </a-spin>
        </section>
      </div>
    </a-spin>
  </div>
</template>

<script>
import {
  getTallClassifyList,
  getTallPage,
  EXAM_FILE_BASE
} from '@/utils/examHallApi.js'

/** 全部 + 2005–2025（数字年份降序） */
function buildYearOptions () {
  const years = []
  for (let y = 2025; y >= 2005; y--) {
    years.push({ label: String(y), value: String(y) })
  }
  return [{ label: '全部', value: '' }, ...years]
}

const YEAR_OPTIONS = buildYearOptions()
/** 折叠时默认展示的年份数量（不含「全部」）：与示意图一致展示近年一排 */
const YEAR_COLLAPSE_COUNT = 12

export default {
  name: 'GaokaoRealExam',
  data () {
    return {
      classifyLoading: false,
      pageLoading: false,
      rawClassify: [],
      selectedClassifyId: '0',
      classifyIdNum: 0,
      yearOptions: YEAR_OPTIONS,
      yearExpanded: false,
      selectedYear: '',
      list: [],
      total: 0,
      pageNum: 1,
      pageSize: 10
    }
  },
  computed: {
    classifyList () {
      const all = { id: '0', title: '全部' }
      return [all, ...this.rawClassify]
    },
    /** 折叠：全部 + 最近 YEAR_COLLAPSE_COUNT 个年份；展开：全部 + 全部年份 */
    displayedYears () {
      const all = this.yearOptions[0]
      const nums = this.yearOptions.slice(1)
      if (this.yearExpanded || nums.length <= YEAR_COLLAPSE_COUNT) {
        return this.yearOptions
      }
      return [all, ...nums.slice(0, YEAR_COLLAPSE_COUNT)]
    },
    canToggleYears () {
      return this.yearOptions.length - 1 > YEAR_COLLAPSE_COUNT
    }
  },
  mounted () {
    this.loadClassify()
    this.loadPage()
  },
  methods: {
    parseClassifyId (id) {
      if (id === '0' || id === 0) return 0
      const n = parseInt(id, 10)
      return Number.isNaN(n) ? 0 : n
    },
    async loadClassify () {
      this.classifyLoading = true
      try {
        const res = await getTallClassifyList()
        const data = res && res.data
        if (data && data.success && Array.isArray(data.resultData)) {
          this.rawClassify = data.resultData
        } else {
          this.rawClassify = []
          if (data && !data.success) {
            this.$message.warning(data.resultMessage || '分类加载失败')
          }
        }
      } catch (e) {
        console.error(e)
        this.$message.error('分类接口请求失败')
        this.rawClassify = []
      } finally {
        this.classifyLoading = false
      }
    },
    async loadPage () {
      this.pageLoading = true
      try {
        const body = {
          classifyId: this.classifyIdNum,
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          year: this.selectedYear
        }
        const res = await getTallPage(body)
        const data = res && res.data
        if (data && data.success && data.resultData) {
          const rd = data.resultData
          this.list = Array.isArray(rd.list) ? rd.list : []
          const t = rd.total
          this.total = typeof t === 'number' ? t : parseInt(t, 10) || 0
        } else {
          this.list = []
          this.total = 0
          if (data && !data.success) {
            this.$message.warning(data.resultMessage || '列表加载失败')
          }
        }
      } catch (e) {
        console.error(e)
        this.$message.error('列表接口请求失败')
        this.list = []
        this.total = 0
      } finally {
        this.pageLoading = false
      }
    },
    onSelectClassify (c) {
      if (this.selectedClassifyId === c.id) return
      this.selectedClassifyId = c.id
      this.classifyIdNum = this.parseClassifyId(c.id)
      this.pageNum = 1
      this.loadPage()
    },
    onSelectYear (value) {
      if (this.selectedYear === value) return
      this.selectedYear = value
      this.pageNum = 1
      this.loadPage()
    },
    onPageChange (page) {
      this.pageNum = page
      this.loadPage()
    },
    onDownload (item) {
      if (!item.filePath) {
        this.$message.warning('文件路径缺失')
        return
      }
      const path = String(item.filePath).replace(/^\//, '')
      const url = EXAM_FILE_BASE + encodeURI(path)
      window.open(url, '_blank')
    }
  }
}
</script>
